import React from 'react'
import ArticulosCompra from '../components/ArticulosCompra'

const articulosDeCompra = () => {
  return (
    <ArticulosCompra />
  )
}

export default articulosDeCompra